import Box from '@mui/material/Box';

import { AddIcon } from 'shared/base';

export function CreateEmptyReportIcon() {
  return (
    <Box
      sx={{
        backgroundColor: 'secondary.dark',
        borderRadius: 1,
        height: 40,
        p: 1,
        width: 40,
      }}
    >
      <AddIcon />
    </Box>
  );
}
